import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { CoreTheme as theme } from '@minecraft.themes';
import Linkify from '@minecraft.linkify';
import { useTranslation } from '@blocs.i18n';
import { SectionTitleWithIcon, SectionTitleIcon } from '../SummaryStyles';

const Note = styled.p`
  margin: 0.625rem 0 0;
`;

type Props = {
  note: string;
};

const SummarySubmissionNote: FC<Props> = ({ note }) => {
  const { t } = useTranslation();
  return (
    !!note && (
      <div>
        <SectionTitleWithIcon>
          <SectionTitleIcon name="submission-note" color={theme.colors.primary.darkGrey} />
          {t('common:profileEdit.submissionNote')}
        </SectionTitleWithIcon>
        <Note>
          <Linkify>{note}</Linkify>
        </Note>
      </div>
    )
  );
};

export default memo<Props>(SummarySubmissionNote);
